import { Formik, Form } from "formik";
import * as Yup from "yup";
import MainLayout from "../../../layout";
import FormTextField from "../../../components/form/text";
import { FormImageField } from "../../../components/form/image";
import { FormTextAreaField } from "../../../components/form/text-area";
import { useNavigate } from "react-router-dom";
import successToast from "../../../components/toast/successToast";
import errorToast from "../../../components/toast/errorToast";
import { FormDateField } from "../../../components/form/date";
import FormPasswordField from "../../../components/form/password";
import { FormDropDown } from "../../../components/form/dropdown";
import { useState } from "react";
import { useEffect } from "react";
import { api } from "../../../redux/apis/api";

const CreateUsers = () => {
  const naviagte = useNavigate();
  const [rolesDropDownList, setRolesDropDownList] = useState([]);
  const [departmentDropDownList, setDepartmentDropDownList] = useState([]);
  const [designationDropDownList, setDesignationDropDownList] = useState([]);

  const initialValues = {
    role_id: "",
    designation_id: null,
    department_id: null,
    profile_picture: "",
    name: "",
    email: "",
    phone_number: "",
    date_of_birth: null,
    password: "",
    gender: "",
    marital_status: null,
    current_address: "",
    permanent_address: "",

    emergency_contact_number: "",
    emergency_contact_name: "",
    emergency_contact_relation: "",

    bank_account_number: "",
    bank_ifsc_code: "",
    bank_name: "",
    bank_account_holder_name: "",
    pan_number: "",
    aadhar_number: "",

    joining_date: null,
    leaving_date: null,
    exit_interview_date: null,
    status: null,

    office_email: "",
    office_phone_number: "",
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string().required("Required").email("Invalid email"),
    password: Yup.string().required("Required"),
  });

  const handleSubmit = (values) => {
    console.log(values, "values");
    api
      .post(`/ffadmin/create`, values)
      .then((response) => {
        successToast(response.message);
        console.log(response, "response");
        naviagte(`/admin/users/list`);
      })
      .catch((error) => {
        console.error("API Error:", error);
        errorToast(error?.response?.data?.message);
      });
  };

  const genderOptions = [
    { label: "Male", value: "male" },
    { label: "Female", value: "female" },
    { label: "Others", value: "others" },
  ];

  const maritalOptions = [
    { label: "Married", value: "married" },
    { label: "Single", value: "single" },
    { label: "Divorced", value: "divorced" },
    { label: "Other", value: "other" },
  ];

  const statusOptions = [
    { label: "Active", value: "active" },
    { label: "Suspended", value: "suspended" },
    { label: "Left", value: "left" },
  ];

  const fetchRolesDropDownData = () => {
    api
      .post(`/ffadmin/role-dropdown`)
      .then((res) => {
        let newArr = res?.data?.data?.rows?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setRolesDropDownList(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  const fetchDesignationList = () => {
    api
      .post(`/ffadmin/designation-dropdown`)
      .then((res) => {
        let newArr = res?.data?.data?.rows?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setDesignationDropDownList(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  const fetchDepartmentList = () => {
    api
      .post(`/ffadmin/depatment-dropdown`)
      .then((res) => {
        let newArr = res?.data?.data?.rows?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setDepartmentDropDownList(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  useEffect(() => {
    fetchRolesDropDownData();
    fetchDesignationList();
    fetchDepartmentList();
  }, []);

  return (
    <MainLayout>
      <section className="h-full overflow-auto px-3">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          <Form>
            <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
              <h2 className="text-xl font-semibold capitalize">
                Admin Users - Create
              </h2>
              <div className="flex gap-3 items-center">
                <button
                  onClick={() => naviagte("/admin/users/list")}
                  type="button"
                  className="px-4 py-1 border-[2px] border-errorColor text-errorColor rounded"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
                >
                  Create
                </button>
              </div>
            </div>
            <div className="bg-[#1D72DB60] rounded-[4px] px-4 py-1">
              <p>Basic Details</p>
            </div>
            <section className="w-full max-w-[40rem]">
              <div className="my-4">
                <FormImageField
                  name={"profile_picture"}
                  label={"profile picture"}
                />
              </div>
              <div className="my-4">
                <FormTextField
                  name={"name"}
                  label={"name"}
                  placeholder={`Enter your name`}
                />
              </div>
              <div className="my-4">
                <FormTextField
                  name={"phone_number"}
                  label={"phone number"}
                  placeholder={`Enter phone number`}
                />
              </div>
              <div className="my-4">
                <FormTextField
                  name={"email"}
                  label={"Email"}
                  placeholder={`Enter your email`}
                />
              </div>
              <div className="my-4">
                <FormPasswordField
                  name={"password"}
                  label={"password"}
                  placeholder={`Enter your password`}
                />
              </div>
              <div className="my-4">
                <FormDateField name={"date_of_birth"} label={"date of birth"} />
              </div>
              <div className="my-4">
                <FormDropDown
                  name="gender"
                  label="Gender"
                  options={genderOptions}
                />
              </div>
              <div className="my-4">
                <FormDropDown
                  name="marital_status"
                  label="marital status"
                  options={maritalOptions}
                />
              </div>
              <div className="my-4">
                <FormTextAreaField
                  name={"current_address"}
                  label={"Current address"}
                  placeholder={`Enter permanent address`}
                  rows={3}
                />
              </div>
              <div className="my-4">
                <FormTextAreaField
                  name={"permanent_address"}
                  label={"permanent address"}
                  placeholder={`Enter permanent address`}
                  rows={3}
                />
              </div>
              <div className="my-4">
                <FormDropDown
                  name="status"
                  label="status"
                  options={statusOptions}
                />
              </div>
              <div className="my-4">
                <FormDropDown
                  name="role_id"
                  label="Role"
                  options={rolesDropDownList}
                />
              </div>
              <div className="my-4">
                <FormDropDown
                  name="department_id"
                  label="department"
                  options={departmentDropDownList}
                />
              </div>
              <div className="my-4">
                <FormDropDown
                  name="designation_id"
                  label="Designation"
                  options={designationDropDownList}
                />
              </div>
              <div className="my-4">
                <FormTextField
                  name={"office_email"}
                  label={"office email"}
                  placeholder={`Enter office email`}
                />
              </div>
              <div className="my-4">
                <FormTextField
                  name={"office_phone_number"}
                  label={"office phone number"}
                  placeholder={`Enter office phone number`}
                />
              </div>
              <div className="my-4">
                <FormDateField name={"joining_date"} label={"joining date"} />
              </div>
              <div className="my-4">
                <FormDateField name={"leaving_date"} label={"leaving date"} />
              </div>
              <div className="my-4">
                <FormDateField
                  name={"exit_interview_date"}
                  label={"exit interview date"}
                />
              </div>
            </section>
            <div className="bg-[#1D72DB60] rounded-[4px] px-4 py-1">
              <p>Bank Details</p>
            </div>
            <section className="w-full max-w-[40rem]">
              <div className="my-4">
                <FormTextField
                  name={"pan_number"}
                  label={"pan number"}
                  placeholder={`Enter pan number`}
                />
              </div>
              <div className="my-4">
                <FormTextField
                  name={"aadhar_number"}
                  label={"aadhar number"}
                  placeholder={`Enter aadhar number`}
                />
              </div>
              <div className="my-4">
                <FormTextField
                  name={"bank_account_number"}
                  label={"account number"}
                  placeholder={`Enter account number`}
                />
              </div>
              <div className="my-4">
                <FormTextField
                  name={"bank_ifsc_code"}
                  label={"bank ifsc code"}
                  placeholder={`Enter ifsc code`}
                />
              </div>
              <div className="my-4">
                <FormTextField
                  name={"bank_name"}
                  label={"bank name"}
                  placeholder={`Enter bank name`}
                />
              </div>
              <div className="my-4">
                <FormTextField
                  name={"bank_account_holder_name"}
                  label={"account holder name"}
                  placeholder={`Enter your account holder name`}
                />
              </div>
            </section>
            <div className="bg-[#1D72DB60] rounded-[4px] px-4 py-1">
              <p className="capitalize">emergency contact details</p>
            </div>
            <section className="w-full max-w-[40rem]">
              <div className="my-4">
                <FormTextField
                  name={"emergency_contact_name"}
                  label={"emergency contact name"}
                  placeholder={`Enter emergency contact name`}
                />
              </div>
              <div className="my-4">
                <FormTextField
                  name={"emergency_contact_number"}
                  label={"emergency contact number"}
                  placeholder={`Enter emergency contact number`}
                />
              </div>
              <div className="my-4">
                <FormTextField
                  name={"emergency_contact_relation"}
                  label={"relation to"}
                  placeholder={`Enter relation to`}
                />
              </div>
            </section>
          </Form>
        </Formik>
      </section>
    </MainLayout>
  );
};

export default CreateUsers;
